var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_826_3640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.917 13C12.6623 14.4801 11.8619 15.8108 10.6739 16.7296C9.48593 17.6484 7.99666 18.0885 6.50009 17.9629C5.00352 17.8373 3.60841 17.1552 2.59016 16.0513C1.57191 14.9474 1.00452 13.5018 1 12C0.998629 10.4946 1.56319 9.0437 2.58168 7.93515C3.60017 6.8266 4.99816 6.14141 6.49828 6.01553C7.9984 5.88965 9.49103 6.33228 10.68 7.25559C11.869 8.1789 12.6675 9.51543 12.917 11H23V13H21V17H19V13H17V17H15V13H12.917ZM7 16C8.06087 16 9.07828 15.5786 9.82843 14.8284C10.5786 14.0783 11 13.0609 11 12C11 10.9391 10.5786 9.92171 9.82843 9.17157C9.07828 8.42142 8.06087 7.99999 7 7.99999C5.93914 7.99999 4.92172 8.42142 4.17158 9.17157C3.42143 9.92171 3 10.9391 3 12C3 13.0609 3.42143 14.0783 4.17158 14.8284C4.92172 15.5786 5.93914 16 7 16Z",
    fill: "#768A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_826_3640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.0db84ca1ceb046f9e5e92b69b20a1619.svg";
export { ForwardRef as ReactComponent };